export const popupUtil = {
  create(Popup, props = {}) {
    const popup = new Popup({
      target: document.body,
      props,
      //  window.__LG__ 兼容老版本
      context: new Map(window.__LG__ ? [['LG', window.__LG__]] : []),
      intro: true,
    });
    popup.$on('close', popup.$destroy);
    return popup;
  },
  wait(Popup, propsCreator) {
    return new Promise((resolve) => {
      const popup = new Popup({
        target: document.body,
        props: propsCreator(resolve),
        //  window.__LG__ 兼容老版本
        context: new Map(window.__LG__ ? [['LG', window.__LG__]] : []),
        intro: true,
      });
      popup.$on('close', popup.$destroy);
    });
  },
};
